import { Icon } from 'gu-ui-kit'
import React, { lazy } from 'react'
import { ROUTES } from 'constants/routes'
import { routes as commonRoutes, withAccess, ROUTE_ACCESS } from '../common/router'
import mergeArraysByKey from 'utils/mergeArraysByKey'

const AccountsMarketplace = lazy(() => import('modules/AccountsMarketplace/Categories'))
const AccountsMarketplaceCategory = lazy(
  () => import('modules/AccountsMarketplace/Category'),
)
const AccountsMarketplaceProducts = lazy(
  () => import('modules/AccountsMarketplace/Products'),
)
const AccountsMarketplaceProduct = lazy(
  () => import('modules/AccountsMarketplace/Product'),
)

const productRoutes = withAccess(
  [
    {
      exact: true,
      path: ROUTES.ACCOUNTS_MARKETPLACE,
      key: 'accounts-marketplace/list',
      label_key: 'accounts_marketplace::navigation.categories',
      page_title_keys: ['accounts_marketplace::title', 'accounts_marketplace::navigation.categories'],
      component: AccountsMarketplace,
      icon: <Icon name="user-add" size="m" />,
      domain: 'accountsMarketplace',
    },
    {
      path: ROUTES.ACCOUNTS_MARKETPLACE_CATEGORY,
      exact: true,
      key: 'accounts-marketplace/category',
      label_key: 'accounts_marketplace::navigation.category',
      page_title_keys: ['accounts_marketplace::title', 'accounts_marketplace::navigation.category'],
      component: AccountsMarketplaceCategory,
      icon: <Icon name="user-add" size="m" />,
      domain: 'accountsMarketplace',
    },
    {
      path: ROUTES.ACCOUNTS_MARKETPLACE_CATEGORY_PRODUCTS,
      exact: true,
      key: 'accounts-marketplace/category-products',
      label_key: 'accounts_marketplace::navigation.products',
      page_title_keys: ['accounts_marketplace::title', 'accounts_marketplace::navigation.products'],
      component: AccountsMarketplaceProducts,
      icon: <Icon name="user-add" size="m" />,
      domain: 'accountsMarketplace',
    },
    {
      path: ROUTES.ACCOUNTS_MARKETPLACE_PRODUCT,
      exact: true,
      key: 'accounts-marketplace/product',
      label_key: 'accounts_marketplace::navigation.product',
      page_title_keys: ['accounts_marketplace::title', 'accounts_marketplace::navigation.product'],
      component: AccountsMarketplaceProduct,
      icon: <Icon name="user-add" size="m" />,
      domain: 'accountsMarketplace',
    },
  ],
  ROUTE_ACCESS.PRIVATE,
)

const routes = mergeArraysByKey(commonRoutes, productRoutes, 'key')

export default routes
export { routes }
